<template>
  <span
    :aria-hidden="props.label ? undefined : true"
    :aria-label="props.label"
    class="pjazza-symbols !inline-flex shrink-0 !leading-none items-center justify-center"
    :role="props.label ? 'img' : undefined"
    :style="{ fontSize: SIZE_PX[props.size ?? 'inline'] }"
  >
    {{ PJ_ICON_GLYPH[props.name] }}
  </span>
</template>

<script lang="ts" setup>
import type { PjIconProps, PjIconSize } from '@/domains/pjazza/components/atoms/pj-icon/PjIcon.types.ts'

import { PJ_ICON_GLYPH } from '@/domains/pjazza/components/atoms/pj-icon/PjIconGlyph.generated.ts'

/**
 * One glyph from Pjazza's own Material Symbols Rounded subset: the `PJ_ICON`
 * set only, at the admin `MaterialIcon` instance, drawn by codepoint.
 *
 * Colour is never set here: a glyph renders as text, so it takes the
 * colour of whatever it sits in exactly the way the old stroke-based sprite
 * did. That is what makes the active/inactive rule work — active is ink,
 * inactive is muted, and neither needs a filled variant.
 *
 * No alias resolution or fallback glyph, unlike the admin `MaterialIcon`:
 * `PjIconName` is a closed, compile-time-checked union of a few names, not a
 * loosely-typed string against a 280-icon shared vocabulary, so there is
 * nothing for a runtime validator to catch that the type checker hasn't
 * already.
 */
const props = defineProps<PjIconProps>()

const SIZE_PX: Record<PjIconSize, string> = {
  nav: '24px',
  inline: '20px',
  meta: '18px',
  // Scales with the words around it — an icon inside a display-size sentence.
  text: '0.66em'
}
</script>
